import ky from 'ky-universal';
import { takeLeading, call, put } from 'redux-saga/effects';
import Cookies from 'js-cookie';

import { LOGOUT } from '../constants/actionTypes';
import authUtils from '../utils/auth';

import { COOKIE_LOG_TRACKING_CLIENT_ID} from '../../constants/cookie';
import { SET_CAMPAIGN_STEP, CAMPAIGN_STEP_NONE } from '../reducers/ui/campaignStep';

function* logout() {
  const accessToken = authUtils.getAccessToken();
  yield call(authUtils.logout);
  yield put ({ // 會員養成
    type: SET_CAMPAIGN_STEP,
    payload: CAMPAIGN_STEP_NONE,
  });

  if (accessToken) {
    const adId = yield authUtils.getClientId();

    yield call(ky.post, '/api/oauth/revoke', {
      json: {
        adId,
        instanceId: Cookies.get(COOKIE_LOG_TRACKING_CLIENT_ID),
        accessToken,
      },
      throwHttpErrors: false,
    });
  }
}

export function* logoutFlow() {
  yield takeLeading(LOGOUT, logout);
}
